import Constants from "expo-constants";
import { MyPlanConstants } from "myplan";
import { useContext, useEffect, useState } from "react";
import { FurnitureContext } from "../furniture";
import { template } from "../locale";
import useStorage from "../storage";

export const STORAGE_KEY_EXTERNAL_RESOURCES = "resources/externalResources";
export const STORAGE_KEY_EXTERNAL_RESOURCES_ZIP =
    "resources/externalResourcesZip";

const { nearbyResourcesApiUrl } = Constants.expoConfig
    ?.extra as MyPlanConstants;

export const getExternalResourceCategoriesByZipCode = async zip => {
    const url = `${nearbyResourcesApiUrl}${zip}`;
    const response = await fetch(url);
    if (response.ok) {
        return await response.json();
    } else {
        return null;
    }
};

export const useNearbyResources = () => {
    const [resourceCategories, setResourceCategories] = useState<
        Object[] | null
    >();
    const [zip, setZip] = useState<string | null>();
    const {
        // @ts-ignore
        strings: { resourcesNearZip, resourcesNearMe },
    } = useContext(FurnitureContext);
    const [title, setTitle] = useState<string | null>();
    const [storedZip, setStoredZip, clearStoredZip] = useStorage(
        STORAGE_KEY_EXTERNAL_RESOURCES_ZIP,
    ) as any;
    const [storedResources, setStoredResources, clearStoredResources] =
        useStorage(STORAGE_KEY_EXTERNAL_RESOURCES) as any;

    const getTitleWithZip: (values: { zip: string }) => string =
        template(resourcesNearZip);
    const createTitle = () => {
        return storedZip
            ? getTitleWithZip({ zip: storedZip })
            : resourcesNearMe;
    };

    const set = (zip: string) => {
        clearStoredResources();
        setResourceCategories(null);
        setZip(zip);
        setStoredZip(zip);
        getExternalResourceCategoriesByZipCode(zip).then(resourceCategories => {
            setResourceCategories(resourceCategories);
            setStoredResources(resourceCategories);
        });
    };

    const clear = () => {
        setZip(null);
        setResourceCategories(null);
        clearStoredZip();
        clearStoredResources();
    };

    const isEnabled = () => {
        return !!nearbyResourcesApiUrl;
    };

    useEffect(() => {
        if (storedZip) {
            setZip(storedZip);
        }
        if (storedResources) {
            setResourceCategories(storedResources);
        }
        setTitle(createTitle());
    });

    return [title, zip, resourceCategories, set, clear, isEnabled];
};
